import "./App.css";
import Footer from "./components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import { Outlet } from "react-router-dom";
import { ToastProvider } from "./components/Toast/ToastContainer";

function App() {
  return (
    <ToastProvider>
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <div className="App">
        <Navbar />
        <main id="main-content" className="main-content">
          <Outlet />
        </main>
        <Footer />
      </div>
    </ToastProvider>
  );
}

export default App;
